export const AutoAddressUat = {
  input: 'autoAddress.input',
  popper: 'autoAddress.popper',
}
